import { Session } from '@ais-ui/auth';

export type LegendColor = {
  name: string;
  color: string;
};

export const mapSetLegendItems = async (
  session: Session,
  itemNameList: string[],
  showItem: boolean,
): Promise<null> => {
  const response = await session.request('setLegendItemDisplayStatus', {
    itemNameList: itemNameList,
    showItem: showItem,
  });

  return response;
};

export const mapLegendColors = async (
  session: Session,
): Promise<LegendColor[]> => {
  const response = await session.request('getLegendColors', {});

  return response;
};
